import PropTypes from 'prop-types';

export const referralInfoPropType = PropTypes.shape({
  isReferral: PropTypes.bool,
  isAffiliate: PropTypes.bool,
  referrerName: PropTypes.string,
  photoUrl: PropTypes.string,
  pl: PropTypes.shape({
    id: PropTypes.string,
    pro: PropTypes.string,
    plus: PropTypes.string,
    basic: PropTypes.string,
    type: PropTypes.string,
  }),
  code: PropTypes.string,
});

export const affiliateInfoPropType = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string  
});

export const shareProgramContextPropType = {
  shareProgramContext: PropTypes.shape({
    referralInfo: referralInfoPropType,
    affiliateInfo: affiliateInfoPropType,
    getGFReferralInfo: PropTypes.func.isRequired,
  }),
};

export const shareProgramContextDefaultProp = {
  shareProgramContext: {
    referralInfo: undefined,
    affiliateInfo: undefined,
  },
};
